const en = {

    campus : "ชื่อสถาบันอุดมศึกษา",
    faculty: "สำนักวิชา",
    department: "สาขาวิชา",
    academicYear:"ปีการศึกษา",
    semester:"ภาคการศึกษา",
    course:"เลือกรายวิชา",


    button: {
        setting:"ตั้งค่า",
        create :"สร้าง",
    },

    description : "รายละเอียด"
}
export default en

